import { msg } from '@lingui/core/macro'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { titleFor } from '~/lib/route-title'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/projects')({
  component: ProjectsLayout,
  head: () => ({ meta: [{ title: titleFor(msg`Projects`) }] }),
})

// Pass-through layout: the list and the full-page detail are child routes.
function ProjectsLayout() {
  return <Outlet />
}
